const errorCodes: Record<number | string, string> = {
  'error.auth.userNotFound': 'Nieprawidłowy e-mail lub hasło',
  'error.auth.credentials': 'Nieprawidłowy e-mail lub hasło',
  'error.auth.exist': 'E-mail jest już zajęty',
  'error.unauthorized': 'Brak autoryzacji',
  'error.forbidden': 'Brak dostępu',
  'error.internalServerError': 'Błąd wewnętrzny serwera',
  'error.badRequest': 'Nieprawidłowe żądanie',
  'error.fileNotFound': 'Plik nie znaleziony',
  'error.userNotFound': 'Użytkownik nie znaleziony',
  'error.invalidCredentials': 'Nieprawidłowe dane logowania',
  'error.invalidResetPasswordToken': 'Nieprawidłowy token resetowania hasła',
  'error.accountBlocked': 'Konto zablokowane',
  'error.accountArchived': 'Konto zarchiwizowane',
  'error.registrationDisabled': 'Rejestracja wyłączona',
  'error.userAlreadyExists': 'Użytkownik już istnieje',
  'error.questionNotFound': 'Nie znaleziono pytania',
  'error.questionNumberExists': 'Numer pytania już istnieje',
  'error.userQuestionEvaluationNotFound': 'Nie znaleziono oceny pytania',
  'error.emailAlreadyVerified': 'Email został już zweryfikowany',
  'error.emailNotVerified': 'Email nie został zweryfikowany',
  'error.invalidEmailVerificationToken': 'Nieprawidłowy token weryfikacji email',
  401: 'Brak uprawnień',
  403: 'Dostęp zabroniony',
  404: '(404)Nie znaleziono',
  413: 'Za duży rozmiar pliku',
  500: 'Wewnętrzny błąd serwera',
  409: 'Email został już użyty',
  400: 'Nieprawidłowe żądanie'
}

const inputErrorCodes: Record<string, string> = {
  'error.email': 'Nieprawidłowy format email',
  'error.required': 'Pole zostało przesłane nieprawidłowo',
  'error.minLength8': 'Minimalna długość to 8 znaków',
  'error.telephone.invalid': 'Nieprawidłowy format telefonu'
}

export function getErrorResponse(code: number | string, key?: string) : string {
  if (key) return inputErrorCodes[code] || 'Wystąpił nieznany błąd'
  return errorCodes[code] || 'Wystąpił nieznany błąd'
}
